module.exports = __webpack_public_path__ + "img/zmd.98922c34.jpg";